import { AssistantChatMessage } from '@stores/assistantStore'
import { observer } from 'mobx-react'

import { useAssistantSession } from './AssistantSessionContext'
import { KW, OptionCard } from './ui'

interface Props {
  message: AssistantChatMessage
}

/**
 * Renders a clarifying question's suggested options as selectable cards.
 * Picking one sends the answer (with the machine value) back to the assistant;
 * the user may also just type in the composer when free text is allowed.
 */
const ClarificationPrompt = ({ message }: Props) => {
  const session = useAssistantSession()
  const clarification = message.clarification
  if (!clarification) {
    return null
  }

  const answered = !!message.clarificationAnswered
  const isPending = session.pendingClarification?.id === message.id

  return (
    <div className="mt-[10px]">
      <div className="flex flex-col gap-2">
        {(clarification.options ?? []).map(option => {
          const selected = message.clarificationSelectedValue === option.value
          return (
            <OptionCard
              key={option.value}
              title={option.label}
              description={option.description}
              selected={selected}
              dimmed={answered && !selected}
              disabled={answered || !isPending || session.isInputLocked}
              onClick={() => session.answerClarification(option)}
            />
          )
        })}
      </div>
      {!answered && isPending && clarification.allowFreeText !== false && (
        <div className="mt-2 text-[11.5px]" style={{ color: KW.muted }}>
          …or type your answer below
        </div>
      )}
    </div>
  )
}

export default observer(ClarificationPrompt)
